// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"styles_modalWrapper__1Oneg","modal":"styles_modal__3K85P"};